// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"215":"4b14bd13","739":"4c91fcc7","810":"079479bd","997":"10b95082"}[chunkId] + ".chunk.js";
};